import { GUEST_REGISTER } from "./../../../redux/feature/LoginFlow/interface/iGuestRegister";
import { ILoginAccountTypes } from "@domains/features/LoginFlow/entities/CommonLoginData";
import { ITimerValues } from "./GuestUser/OtpPage";

export const otpValidityTime: ITimerValues = {
  min: 9,
  sec: 59,
};

export enum loginScreenState {
  LOGIN = "LOGIN",
  PASSWORD = "PASSWORD",
  OTP = "OTP",
  CHOOSE_ACCOUNT = "CHOOSE_ACCOUNT",
  FORGOT_LOGIN_ID = "FORGOT_LOGIN_ID",
  FORGOT_PASSWORD = "FORGOT_PASSWORD",
  UNBLOCK_USER_TYPE = "UNBLOCK_USER_TYPE",
  UNBLOCK_USER = "UNBLOCK_USER",
  DEFAULT = "DEFAULT",
  GUEST_LOGIN = "GUEST_LOGIN",
  GUEST_LOGIN_MPIN = "GUEST_LOGIN_MPIN",
  GUEST_LOGIN_TRIAL = "GUEST_LOGIN_TRIAL",
  GUEST_REGISTER = "GUEST_REGISTER",
  GUEST_VERIFY_MOBILE_OTP = "GUEST_VERIFY_MOBILE_OTP",
  GUEST_VERIFY_EMAIL_OTP = "GUEST_VERIFY_EMAIL_OTP",
  GUEST_SET_MPIN = "GUEST_SET_MPIN",
  GUEST_EMAIL = "GUEST_EMAIL",
  GUEST_FORGOT_MPIN = "GUEST_FORGOT_MPIN",
  LOGIN_HELP = "LOGIN_HELP",
  MOBILE_APP = "MOBILE_APP",
  EXTERNAL_OTP = "EXTERNAL_OTP",
}

export enum forgotLoginIdState {
  FORGOT_LOGIN_ID = "FORGOT_LOGIN_ID",
  SUCCESS_STATE = "SUCCESS_STATE",
  FAILIURE_STATE = "FAILIURE_STATE",
}

export enum forgotPasswordState {
  NEW_PASSWORD = "NEW_PASSWORD",
  FORGOT_PASSWORD = "FORGOT_PASSWORD",
  SUCCESS_STATE = "SUCCESS_STATE",
  SECURE_LOGIN = "SECURE_LOGIN",
  OTP = "OTP",
}

export enum unblockUserState {
  UNBLOCK_USER = "UNBLOCK_USER",
  SUCCESS_STATE = "SUCCESS_STATE",
  UNBLOCK_USER_TYPE = "UNBLOCK_USER_TYPE",
}
export enum externalTOTP {
  DISABLED_TOTP = "DISABLED_TOTP",
  FAILED_DISABLE_TOTP = "FAILED_DISABLE_TOTP",
  VERIFY_OTP_TOTP = "VERIFY_OTP_TOTP",
  SUCESSFULLY_TOTP = "SUCESSFULLY_TOTP",
  FAILED_TOTP = "FAILED_TOTP",
  FAILED_SECRET_KEY = "FAILED_SECRET_KEY",
  CHANGE_AUTHENTICATE_TOTP = "CHANGE_AUTHENTICATE_TOTP",
  EXTERNAL_SCAN_TOTP = "EXTERNAL_SCAN_TOTP",
  SUCESSFULLY_EXTERNAL_TOTP = "SUCESSFULLY_EXTERNAL_TOTP",
  SWITCH_EXTERNAL_TOTP = "SWITCH_EXTERNAL_TOTP",
}
export enum changePassword {
  CHANGE_PASSWORD = "CHANGE_PASSWORD",
  PASSWORD_CHANGED = "PASSWORD_CHANGED",
  PASSWORD_FAILED = "PASSWORD_FAILED",
}
export interface IAccountDetails {
  accTyp: string;
  userID: ILoginAccountTypes;
  pan: string;
}

export const handleNavigateUrl = (baseUrl: string, redirectQuery?: string) => {
  if (redirectQuery) {
    return `${baseUrl}?redirectUrl=${encodeURIComponent(redirectQuery)}`;
  } else {
    return baseUrl;
  }
};

export enum EAccountType {
  CO = "CO",
  EQ = "EQ",
  COMEQ = "COMEQ",
}

export enum NuvamaOneAppJourney {
  Partner = "https://nuvama.page.link/LoginPartner",
  WealthManager = "https://nuvama.page.link/Login",
}
